import React from "react"

const YoutubeIcon = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="white" />
      <path
        d="M32.8954 32.4705H15.9528C13.6858 32.4705 11.8594 30.4656 11.8594 27.9996V20.0002C11.8594 17.5241 13.695 15.5293 15.9528 15.5293H32.8954C35.1623 15.5293 36.9888 17.5342 36.9888 20.0002V27.9996C36.9979 30.4756 35.1623 32.4705 32.8954 32.4705Z"
        fill="#111A2F"
      />
      <path
        d="M28.8695 23.8746L21.7422 19.7646V27.9846L28.8695 23.8746Z"
        fill="white"
      />
    </svg>
  )
}

export default YoutubeIcon
